import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarPrecoPublicoDs,
  criarTaxasDs,
} from "../../DataSources";
import DataSource from "devextreme/data/data_source";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  taxaId: undefined,
  prefeituraId: undefined,
  descricao: "",
  precoPorUnidade: undefined,
  unidadeCalculo: "",
};

export default class PrecoPublicoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.precoPublicoDs = criarPrecoPublicoDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    this.taxas = [];
    this.taxasStore = new DataSource({
      store: {
        data: this.taxas,
        type: "array",
        key: "id",
      },
    });
    this.taxasOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: this.taxasStore,
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };
  }

  componentDidMount() {
    criarTaxasDs()
      .load()
      .then((data) => {
        data.map((x) => {
          console.log(x);
          this.taxas.push(x);
        });
      });
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.precoPublicoDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Preço Público não encontrado.", "error");
              this.props.history.push("/precopublico");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="PREÇO PÚBLICO" colSpan={2} colCount={3}>
              <SimpleItem dataField={"descricao"} colSpan={3}>
                <Label text="Descrição" />
              </SimpleItem>
              <SimpleItem
                dataField={"precoPorUnidade"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                }}
                colSpan={1}
              >
                <Label text="Preço por Unidade" />
              </SimpleItem>
              <SimpleItem dataField={"unidadeCalculo"} colSpan={1}>
                <Label text="Unidade de Cálculo" />
              </SimpleItem>
              <SimpleItem
                dataField={"taxaId"}
                editorType={"dxLookup"}
                editorOptions={this.taxasOptions}
                colSpan={1}
              >
                <Label text="Taxa" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.precoPublicoDs, entidade)
      .then(
        function () {
          notify("Preço Público cadastrada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
